import Image from "next/image";
import type { List, Spot, User } from "@prisma/client";
import NavigationLink from "../NavigationLink";

export default function ListView({
  list,
}: {
  list: List & {
    user: User;
    spots: Spot[];
  };
}) {
  return (
    <NavigationLink
      href={`/guides/${list.slug}`}
      prefetch={false}
      className="pb-[3px] md:h-[390px] md:w-full md:min-w-[353px]"
    >
      <div className="relative mt-2 h-96">
        <Image
          className="guides-img-item absolute -top-[8px] h-[80%] rounded-lg bg-gray-700 object-cover"
          alt="Rectangle"
          src="/img/rectangle-17-2.png"
          width={336}
          height={300}
        />
        <Image
          className="border-neutral-200 absolute rounded-lg border-t-2 object-cover"
          src={list.photos[0] ?? "/images/image-cover-" + (1 + (list.spots.length % 9)) + ".png"}
          alt=""
          fill
        />
        <div className="absolute left-4 top-4 w-3/4 font-medium text-white">
          <div className="mb-2 flex items-center gap-2">
            {list.user.image && (
              <div className="relative h-5 w-5">
                <Image className="rounded-full object-cover" src={list.user.image} alt="" fill />
              </div>
            )}
            <div className="text-xs">{list.user.displayName}</div>
          </div>
          <div className="font-mackinac text-2xl">{list.name}</div>
        </div>
        <div className="absolute bottom-4 right-4 rounded-lg bg-[#000000bf] p-2.5 text-sm font-semibold text-white">{`${list.spots.length} spot${list.spots.length > 1 ? "s" : ""}`}</div>
      </div>

      {/*{collaborator && <UserGroupIcon className="h-5 w-5" />}*/}

      {/*<div className="mt-4 flex px-4">*/}
      {/*  <div className="group relative">*/}
      {/*    {list.user.image && (*/}
      {/*      <div className="relative h-8 w-8">*/}
      {/*        <Image className="rounded-full object-cover" src={list.user.image} alt="" fill />*/}
      {/*      </div>*/}
      {/*    )}*/}
      {/*  </div>*/}
      {/*  <div className="ml-3 flex-1">*/}
      {/*    <h3 className="line-clamp-1">{list.name}</h3>*/}
      {/*    <div className="line-clamp-3 text-xs font-light">{list.description}</div>*/}
      {/*    {list.collaborators.length != 0 && (*/}
      {/*      <div className="mt-1 flex flex-row">*/}
      {/*        <div className="mr-2 mt-1 text-left text-xs font-light text-gray-900">Collaborators</div>*/}
      {/*        <div className="flex gap-x-1">*/}
      {/*          {list.collaborators.map((c) => (*/}
      {/*            <div key={c.id}>*/}
      {/*              <UserIcon user={c.user} showDisplayName={false} size={6} link={false} />*/}
      {/*            </div>*/}
      {/*          ))}*/}
      {/*        </div>*/}
      {/*      </div>*/}
      {/*    )}*/}
      {/*  </div>*/}
      {/*</div>*/}
    </NavigationLink>
  );
}
